export const SEND_EMAIL_OTP = '/user/otp/email-verification/v1/send';
export const RESEND_EMAIL_OTP = '/user/otp/email-verification/v1/resend';
export const VERIFY_EMAIL_OTP = '/user/otp/email-verification/v1/verify';
